import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { getArticleDateTime } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewLocal, setWpNewLocal } from '../../service/wp-blogs-store'
import { getWpNewPostsByCategory } from '../../lib/service'
import LazyYouTubeEmbed from '@/commons/LazyYouTubeEmbed'

export async function getStaticProps() {

    const { modifiedDate, month, year } = getArticleDateTime();
    const localBlogs = blogsMaster['local'].blogArray;
    const wpNewPosts = getWpNewLocal().length > 0 ?  getWpNewLocal() : await getWpNewPostsByCategory(6, "local");
    setWpNewLocal(wpNewPosts)

  return {
      props: {
        modifiedDate,
        month,
        year,
        localBlogs,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const localBlogs = props.localBlogs
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>Top 5 Restaurants in Jewel Changi with Unique Food</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Jewel on Changi airport offers several options of delicious food and restaurant options to travelers and locals. Here are the top 5 restaurants in Jewel!"/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/jewel-changi-food" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Top 5 Restaurants in Jewel Changi with Unique Food`}/>
        <meta property="og:description" content="Jewel on Changi airport offers several options of delicious food and restaurant options to travelers and locals. Here are the top 5 restaurants in Jewel!" />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-15T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/local/jewel-changi.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/local/jewel-changi.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/jewel-changi-food"/>
        <meta name="twitter:title" content={`Top 5 Restaurants in Jewel Changi with Unique Food`}/> 
        <meta name="twitter:description" content="Jewel on Changi airport offers several options of delicious food and restaurant options to travelers and locals. Here are the top 5 restaurants in Jewel!"/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/jewel-changi-food" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/jewel-changi-food"},"headline":"Top 5 Restaurants in Jewel Changi with Unique Food","description":"Jewel on Changi airport offers several options of delicious food and restaurant options to travelers and locals. Here are the top 5 restaurants in Jewel!","image":["https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/local/jewel-changi.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-20T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"VideoObject","name":"Burger and Lobster in 1 Minute","description":"Burger and Lobster in 1 Minute","thumbnailUrl":"https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/local/burger-and-lobster.jpg","uploadDate":"2022-10-03","duration":"PT1M42S","contentUrl":"https://www.youtube.com/embed/ISVV0h1FpQk","embedUrl":"https://www.youtube.com/embed/ISVV0h1FpQk"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":1,"name":"jewel-changi-food"}]}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-5 px-2'>
            <div className='space-y-2'>
                <h1 className='text-2xl text-gray-500 font-semibold'>Top 5 Restaurants in Jewel Changi with Unique Food</h1>
                <div className='text-gray-400 text-xs'>
                    <time dateTime={modifiedDate}>{new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                </div>
            </div>
            <div className='py-10 text-gray-500 leading-8 space-y-5'>
                <div className='space-y-5'>
                    <h2 className='font-bold text-lg'>Looking for food at Jewel Changi?</h2>
                    <p className=''>
                        Jewel on Changi airport offers several options of delicious food and restaurant options to travelers and locals. Here are the 5 best restaurants in Jewel
                        that will keep tempting you for multiple visits! All restaurants on this least are rated at least 4 stars on google reviews with more than 100 reviews.
                    </p>
                </div>
                <div className='relative h-96 max-w-xl'>
                    <Image className='rounded-lg'
                            src={s3Static + "blog/local/jewel-changi.jpg"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Jewel at Changi Airport'
                    />          
                </div>
                <div className='space-y-10 py-10'>
                    <div className='space-y-5'>
                        <h3 className='font-bold text-xl'>
                            1. Poulet Bijou
                        </h3>                        
                        <div className='relative h-96 max-w-xl'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/local/Poulet-Bijou.webp"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Poulet Bijou Jewel Changi'
                            />  
                        </div>                    
                        <i className='text-sm'>Image credit - Poulet Bijou</i> 
                        <p>
                            Poulet Bijou is the most popular French restaurant in the Eastern region of Singapore situated within the premises of Jewel Changi.
                            The bright warm lighting with a hint of greenery gives the restaurant a modern and fresh ambience.
                            <br/><br/>
                            Poulet Bijou is famous for its series of roasted chicken, you can try it with Mushroom Cream Sauce, Cranberry Sauce or with Diane Sauce. Among
                            other popular dishes are the Gilled Ribeye with Mushroom Gratin and Creamy Salmon Pot Pie.
                            <br/> Do not miss out on their mouthwatering Salted Caramel French Toast.
                        </p>
                        <p>
                            <strong>Opening hours</strong>: Daily, 11:30AM - 10:00PM
                        </p>
                        <p>
                            <strong>Address</strong>: 78 Airport Road Jewel 01 - 227, Singapore Changi Airport, 819666
                        </p>
                        <p>
                            <strong>Website</strong>: <a href="https://www.poulet.com.sg/" rel="noreferrer noopener nofollow" className='text-orange-600'>https://www.poulet.com.sg/</a>
                        </p>
                        <p>
                            <strong>Google Rating</strong>: 4.8 stars
                        </p>
                    </div>
                    <div className='space-y-5'>
                        <h3 className='font-bold text-xl'>
                            2. Arteastiq DePatio
                        </h3>
                        <div className='relative h-96 max-w-xl'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/local/Arteastiq-DePatio.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Arteastiq DePatio Jewel Changi'
                            />  
                        </div>                    
                        <i className='text-sm'>Image credit - Arteastiq DePatio</i> 
                        <p>
                            Arteastiq DePatio brings to you the most famous European street style dining experience in Jewel Changi. 
                            When at Jewel Changi we strongly recommended to try them out, however prior reservation might be needed. The restaurant is very well designed and decorated
                            with lots of indoor plants and trees. Their outdoor sitting is something that attracts most travelers.
                            <br/><br/>
                            When it comes to food, this place is perfect to foodies to try out the various option like pizzas, pastas, quesadillas and soups. Among the street food 
                            options you may try the Pancetta Roast Pork Belly or the Tuscan Pork Rib.
                            From the main course you may pick the French Affection Ribeye or the Tuscan butter Salmon.
                        </p>
                        <p>
                            <strong>Opening hours</strong>: Sun - Thurs: 11:00AM - 10PM | Fri, Sat & Eve of PH: 11:00AM - 12:00AM
                        </p>
                        <p>
                            <strong>Address</strong>: 78 Airport Blvd., #05 - 200, Singapore Changi Airport, 819666
                        </p>
                        <p>
                            <strong>Website</strong>: <a href="https://arteastiqdepatio.com/" rel="noreferrer noopener nofollow" className='text-orange-600'>https://arteastiqdepatio.com/</a>
                        </p>
                        <p>
                            <strong>Google Rating</strong>: 4.8 stars
                        </p>
                    </div>
                    <div className='space-y-5'>
                        <h3 className='font-bold text-xl'>
                            3. Burger & Lobster
                        </h3>
                        <div className='relative h-96 max-w-xl'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/local/burger-and-lobster.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Burger & Lobster Jewel Changi'
                            />  
                        </div>                    
                        <i className='text-sm'>Image credit -Burger & Lobster</i> 
                        <p>
                            Burger & Lobster is a famous UK chain which serves only two dishes they are best at -
                            <br/>
                            1. The Prime burgers
                            <br/>
                            2. Atlantic Lobster     
                            <br/>
                            Both the options are highly recommended to try out as they have been optimized for the best taste and are quite popular among burger and lobster lovers.                      
                        </p>
                        <div className='text-center'>
                            <i className='text-sm'>Watch this 1 minute video by Burger and Lobster</i> 
                            <LazyYouTubeEmbed videoId="ISVV0h1FpQk" title="Restaurants in Jewel Changi Singapore" />
                        </div>
                        <p>
                            <strong>Opening hours</strong>: Mon - Thurs: 11:00AM - 9:30PM | Fri - Sun: 11:00AM - 10:00PM
                        </p>
                        <p>
                            <strong>Address</strong>: 78 Airport Blvd., #05 - 203, Singapore 819666
                        </p>
                        <p>
                            <strong>Website</strong>: <a href="https://www.burgerandlobster.com/" rel="noreferrer noopener nofollow" className='text-orange-600'>https://www.burgerandlobster.com/</a>
                        </p>
                        <p>
                            <strong>Google Rating</strong>: 4.4 stars
                        </p>
                    </div>
                    <div className='space-y-5'>
                        <h3 className='font-bold text-xl'>
                            4. Perch
                        </h3>
                        <div className='relative h-96 max-w-xl'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/local/perch.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Perch Jewel Changi'
                            />  
                        </div>  
                        <i className='text-sm'>Image credit - Perch</i> 
                        <p>
                            Perch in Jewel Changi has got one of the most beautiful interiors with a view of the Jewel waterfall (HSBC Rain Vortex). It is the
                            first integrative wine-and-dine concept, developed by Singapore’s leading wine & spirits retailer – 1855 The Bottle Shop and 
                            hospitality group, 1855 F&B Pte Ltd. 
                            <br/><br/>
                            The bistro serves imaginative yet familiar Asian-European fusion dishes rich in Southeast Asian flavours, 
                            that is artfully complemented with a tipple off 1855 The Bottle Shop’s extensive wine selection. Perch is an all-day, casual dining oasis – a 
                            sanctuary amidst the bustle – to unwind, indulge and be inspired with your family.
                        </p>
                        <p>
                            <strong>Opening hours</strong>: Daily, 11:30AM - 10:30PM
                        </p>
                        <p>
                            <strong>Address</strong>: 78 Airport Blvd., #02-244/245 Singapore Changi Airport, 819666
                        </p>
                        <p>
                            <strong>Website</strong>: <a href="https://perch.sg/" rel="noreferrer noopener nofollow" className='text-orange-600'>https://perch.sg/</a>
                        </p>
                        <p>
                            <strong>Google Rating</strong>: 4.1 stars
                        </p>
                    </div>
                    <div className='space-y-5'>
                        <h3 className='font-bold text-xl'>
                            5. Shake Shack - Fast Food
                        </h3>
                        <div className='relative h-96 max-w-xl'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/local/shake-shack.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Shake Shack Jewel Changi'
                            />  
                        </div>                    
                        <i className='text-sm'>Image credit - Shake Shack</i> 
                        <p>
                            Shake Shack is a modern-day <q>roadside</q> burger stands known for its 100% all-natural Angus beef burgers, flat-top beef dogs (no hormones or antibiotics – ever), 
                            frozen custard, crinkle cut fries, craft beer and more.
                        </p>
                        <p>
                        With fresh, high-quality food at a great value, Shake Shack is a fun and lively community gathering place with widespread appeal. As the first Shack in 
                        Southeast Asia, Shake Shack Singapore will continue to promote the global mission – Stand for Something Good®. This includes using only premium 
                        ingredients, adopting best practice in hiring, celebrating inspiring designs, and promoting strong communities&apos; ties.
                        </p>
                        <p>
                            <strong>Opening hours</strong>: Daily, 10:30AM - 10:00PM
                        </p>
                        <p>
                            <strong>Address</strong>: 78 Airport Blvd., #02 - 256, Singapore 819666
                        </p>
                        <p>
                            <strong>Website</strong>: <a href="https://www.shakeshack.com.sg/jewel-changi/" rel="noreferrer noopener nofollow" className='text-orange-600'>https://www.shakeshack.com.sg/jewel-changi/</a>
                        </p>
                        <p>
                            <strong>Google Rating</strong>: 4.1 stars
                        </p>
                    </div>
                </div>
            </div>
            <BlogsList blogs={localBlogs} wpNewPosts={wpNewPosts}/>
        </div>        
      <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}